import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AgentService from "../../services/agent.service";

export const getAgent = createAsyncThunk(
  "agent/getAgent",
  async (params, thunkAPI) => {
    try {
      const response = await AgentService.getagent(params);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const addAgent = createAsyncThunk(
  "agent/addAgent",
  async (data, thunkAPI) => {
    try {
      const response = await AgentService.addagent(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const updateAgent = createAsyncThunk(
  "agent/updateAgent",
  async (payload, thunkAPI) => {
    try {
      const response = await AgentService.editagent(payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const deleteAgent = createAsyncThunk(
  "agent/deleteAgent",
  async (id, thunkAPI) => {
    try {
      await AgentService.deleteagent(id);
      return id;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

/* =================== State =================== */

const initialState = {
  loading: false,
  error: null,
agentList: {
  agents: [],
  total: 0,
  page: 1,
},
  updateSuccess: false,
};

/* =================== Slice =================== */

const agentslice = createSlice({
  name: "agent",
  initialState,
  reducers: {
    resetUpdateStatus: (state) => {
      state.updateSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder

      /* ---------- Get ---------- */
      .addCase(getAgent.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAgent.fulfilled, (state, action) => {
        state.loading = false;
state.agentList = {
  agents: action.payload?.agents || [],
  total: action.payload?.total || 0,
  page: action.payload?.page || 1,
};
      })
      .addCase(getAgent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Add ---------- */
      .addCase(addAgent.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addAgent.fulfilled, (state, action) => {
        state.loading = false;
        const newHotel =
          action.payload?.data ||
          action.payload?.agents ||
          action.payload;

        if (newHotel) {
      state.agentList.agents.unshift(newHotel);
        }
      })
      .addCase(addAgent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Update ---------- */
      .addCase(updateAgent.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.updateSuccess = false;
      })
      .addCase(updateAgent.fulfilled, (state, action) => {
        state.loading = false;
        state.updateSuccess = true;

        const updated =
          action.payload?.data || action.payload?.agents;

        if (updated?._id) {
         const index = state.agentList.agents.findIndex(
            (item) => item._id === updated._id
          );
          if (index !== -1) {
            state.agentList[index] = updated;
          }
        }
      })
      .addCase(updateAgent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Delete ---------- */
      .addCase(deleteAgent.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteAgent.fulfilled, (state, action) => {
        state.loading = false;
     state.agentList.agents = state.agentList.agents.filter(
  (item) => item._id !== action.payload
);
      })
      .addCase(deleteAgent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetUpdateStatus } = agentslice.actions;
export default agentslice.reducer;
